/**
 * Determines CCTV playback mode from html5_player_link.
 *
 * - legacy     : fp.streamonweb.com, chennaistream.net
 *                → direct token-based URL + iframe/m3u8 (old 5.1.2 path)
 *
 * - embed_test : test.streamonweb.com
 *                → POST-embed with MD5 hash (no live flag) + optional hybrid app-auth
 *
 * - embed_live : aivmsfp.streamonweb.com
 *                → same player flow as embed_test, but fetchEmbedHash({ live: true })
 *                  so the backend uses EMBED_SECRET_KEY_LIVE to generate the hash
 */

export const LEGACY_HTML5_PLAYER_PREFIXES = [
    "https://fp.streamonweb.com",
    "https://chennaistream.net",
];

export const EMBED_TEST_HOST = "test.streamonweb.com";
export const EMBED_LIVE_HOST = "aivmsfp.streamonweb.com";

/**
 * @param {string} [html5PlayerLink]
 * @returns {'legacy' | 'embed_test' | 'embed_live'}
 */
export function getCctvPlayerMode(html5PlayerLink) {
    const link = String(html5PlayerLink || "").trim();
    if (!link) return "legacy";
    const lower = link.toLowerCase();

    for (const prefix of LEGACY_HTML5_PLAYER_PREFIXES) {
        if (lower.startsWith(prefix.toLowerCase())) return "legacy";
    }

    if (lower.includes(EMBED_LIVE_HOST)) return "embed_live";
    if (lower.includes(EMBED_TEST_HOST)) return "embed_test";

    return "legacy";
}
